export const getEventName = ({ dt, sc }: { dt: Record<string, string>; sc: string }) => {
  if (sc.includes('cv/re')) {
    let elementType = '';
    let elementName = '';
    try {
      const data = JSON.parse(dt.data);
      elementType = data.elementType;
      elementName = data.elementName;
    } catch (e) {
      console.error('Error parsing JSON data:', e);
    }
    if (dt.name == 'conviva_click') {
      if (elementType) {
        return `conviva_${elementType}_click`;
      }
      if (elementName) {
        return `conviva_${elementName}_click`;
      }
    }
    return dt.name;
  }

  let eventName = sc;

  if (sc.includes('cv/bc')) {
    eventName = 'conviva_button_click';
  } else if (sc.includes('cv/nr')) {
    eventName = 'conviva_network_request';
  } else if (sc.includes('cv/ve')) {
    eventName = 'conviva_video_event';
  } else if (sc.includes('sp/ae')) {
    eventName = 'conviva_application_error';
  } else if (sc.includes('sp/afg')) {
    eventName = 'conviva_application_foreground';
  } else if (sc.includes('sp/abg')) {
    eventName = 'conviva_application_background';
  } else if (sc.includes('spm/ai')) {
    eventName = 'conviva_application_install';
  } else if (sc.includes('sp/de')) {
    eventName = 'conviva_diagnostic_error';
  } else if (sc.includes('spm/sv')) {
    eventName = 'conviva_screen_view';
  }

  return eventName;
};

export const getEventAttributes = (
  eventName: string,
  event: { dt: Record<string, string>; sc: string },
) => {
  if (event.dt.data) {
    const data = JSON.parse(event.dt.data);
    // if (eventName.includes('_click')) {
    //   data['Button Text'] = data.elementText || data.currentTitle;
    // }
    return data;
  }

  if (eventName === 'conviva_network_request') {
    const data = { ...event.dt };
    data['Target Url'] = data.targetUrl.toString();
    data['Network Request Response Code'] = data.responseStatusCode.toString();
    return data;
  }
  return event.dt;
};
